import React from "react";

/**
 * Input with some basic styling. I didn't use antd/Input since it doesn't work well with react-hook-form out of box. Some special handling needed that involves the Controller component from react-hook-form.
 */
export const Input: React.FC<React.InputHTMLAttributes<HTMLInputElement>> =
  React.forwardRef(({ className, ...props }, ref: any) => (
    <input {...props} ref={ref} className={`${className} border p-2`} />
  ));
